import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActiveCartFacade, Cart } from "@spartacus/cart/base/root";
import { combineLatest, map, Observable } from 'rxjs';
import { GenAutoShipActiveCartService } from '../../services/auto-ship-active-cart.service';

interface MiniCartData {
  url: string;
  target: string;
  title: string;
  items: string;
  disabled: boolean;
}

@Component({
  selector: 'gen-mini-cart',
  templateUrl: './mini-cart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenMiniCartComponent {

  constructor(
    protected readonly activeCartFacade: ActiveCartFacade,
    protected readonly autoShipActiveCartService: GenAutoShipActiveCartService,
  ) {
  }

  readonly data$: Observable<MiniCartData> =
    combineLatest([
      this.activeCartFacade.getActive(),
      this.autoShipActiveCartService.isAutoShipRoute$,
      this.autoShipActiveCartService.isAutoShipPage$,
    ]).pipe(
      map(([cart, isAutoShipRoute, disabled]: [Cart | undefined, boolean, boolean]) => {
        const itemCount = cart?.deliveryItemsQuantity ?? 0;

        return {
          url: isAutoShipRoute ? GenAutoShipActiveCartService.CART_URL : '/cart',
          target: '_self',
          disabled,
          items: itemCount > 9 ? '9+' : `${itemCount}`,
          title: `${itemCount} item${itemCount !== 1 ? 's' : ''} currently in your cart`,
        };
      })
    );
}
